export function parseDate(value) {
  if (!value) return null;
  const text = String(value).slice(0, 10);
  const [y, m, d] = text.split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

export function formatDate(value) {
  const date = parseDate(value);
  if (!date) return "";
  const d = String(date.getDate()).padStart(2, "0");
  const m = String(date.getMonth() + 1).padStart(2, "0");
  return `${d}.${m}.${date.getFullYear()}`;
}

export function formatShort(value) {
  const date = parseDate(value);
  if (!date) return "";
  const d = String(date.getDate()).padStart(2, "0");
  const m = String(date.getMonth() + 1).padStart(2, "0");
  if (date.getFullYear() === new Date().getFullYear()) return `${d}.${m}`;
  return `${d}.${m}.${String(date.getFullYear()).slice(2)}`;
}

export function daysWord(count) {
  const n = Math.abs(count);
  if (n === 1) return "dzień";
  return "dni";
}
